import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthService } from 'src/app/utility/auth/auth.service';

import { AppComponent } from 'src/app/app.component';

import { BillingAnalyzeComponent } from '@serengeti/serengeti-billing';
import { BillingCloudListComponent } from '@serengeti/serengeti-billing';
import { BillingCloudDetailComponent } from '@serengeti/serengeti-billing';
import { BillingPriceListComponent } from '@serengeti/serengeti-billing';

import { BillingReportDetailComponent } from '@serengeti/serengeti-billing';
import { BillingLowestComponent } from '@serengeti/serengeti-billing';



const routes: Routes = [
	{ path: 'main', component: AppComponent, canActivate: [AuthService], children: [
		{ path: 'billing/cloud/list', component: BillingCloudListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'billing.list.title', root: true }},
		{ path: 'billing/cloud/create', component: BillingCloudDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'billing.detail.title'}},
		{ path: 'billing/cloud/:id/', component: BillingCloudDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'billing.detail.title'}},
		{ path: 'billing/price/list', component: BillingPriceListComponent, outlet: 'content', canActivate: [AuthService],
		data: { title: 'billing.price.title'}},
		{ path: 'billing/report/detail', component: BillingReportDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'billing.price.title', root: true}},
    { path: 'billing/lowest', component: BillingLowestComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'billing.calculator.title', root: true}},
    { path: 'billing/analyze', component: BillingAnalyzeComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'billing.analyze.title', root: true}},
	]}
];

@NgModule({
	declarations: [],
	imports: [
		RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
		CommonModule
	]
})
export class AppRoutingBillingModule { }
